import React from 'react'
import PropTypes from 'prop-types'
import upperCase from 'lodash/upperCase'
import {useTranslation} from 'react-i18next'

function Users({audit}) {
  const {t} = useTranslation()
  return (
    <div className="audit-expand__column audit-expand__column--users audit--border-radius">
      <p className="audit__label mb_9">{upperCase(`${t('audit.expand.labels.assigned_to')}`)}</p>
      <div className="audit-expand__column--height">
        {audit?.audit_users_attributes?.length > 0 &&
          audit?.audit_users_attributes.map(user => (
            <p className="audit__value audit__value--13 mb_2">
              {audit?.individual_audit && audit?.audit_type !== 'template' ? (
                <span
                  className={
                    user.status === 'completed'
                      ? 'audit_user--statusgreen'
                      : 'audit_user--statusred'
                  }
                ></span>
              ) : null}
              <span>{user.user_name}</span>
            </p>
          ))}
      </div>
    </div>
  )
}

Users.propTypes = {
  audit: PropTypes.shape({}).isRequired,
}

Users.displayName = 'Users'

export default Users
